// This file is generated by a script and should not be modified directly.
const markdown: string =
  "Workplace is described by :\n\n- The name (brand name or, failing that, the company name) and the SIRET number of the company.\n- The description of the employer and/or the department where the contract will be carried out.\n- The company's workforce range, in terms of the number of employees.\n- The company's website.\n"
export default markdown
